import React, {useState, useEffect} from "react";
import Slider from '../components/Slider';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../components/footer.css';
import "./Landing.css";
import { getPageTitle } from '../constants';

const Landing = () => {
  const [translations, setTranslations] = useState<Record<string, string>>({});

  useEffect(() => {
    document.title = getPageTitle('Home');
  }, []);

  return (
    <div id="wrap">
      <Header translations={translations} />

      <div className="col-xs-12 col-sm-12">
        <Slider/>
      </div>

      <div className="col-xs-12 col-sm-12" style={{backgroundColor: "var(--bg-section)"}}>
        <h2 style={{textAlign: "center", maxWidth: "80%", margin: "auto", padding: "100px 0"}}>
          {translations["message.content.about"]}
        </h2>
      </div>

      <div className="features-grid">
        <div className="feature-card feature-red">
          <img className="feature-icon" src="/images/pic1.png" alt="Create your profile with favourite games and skills" />
          <p className="feature-text">{translations["message.content.ad1"]}</p>
        </div>
        <div className="feature-card feature-orange">
          <img className="feature-icon" src="/images/pic2.png" alt="Use map to point places or events" />
          <p className="feature-text">{translations["message.content.ad2"]}</p>
        </div>
        <div className="feature-card feature-yellow">
          <img className="feature-icon" src="/images/pic3.png" alt="Meet new people" />
          <p className="feature-text">{translations["message.content.ad3"]}</p>
        </div>
        <div className="feature-card feature-green">
          <img className="feature-icon" src="/images/pic4.png" alt="Events calendar" />
          <p className="feature-text">{translations["message.content.ad4"]}</p>
        </div>
        <div className="feature-card feature-blue">
          <img className="feature-icon" src="/images/pic5.png" alt="Mark skill experience" />
          <p className="feature-text">{translations["message.content.ad5"]}</p>
        </div>
        <div className="feature-card feature-brown">
          <img className="feature-icon" src="/images/pic6.png" alt="Organize teams" />
          <p className="feature-text">{translations["message.content.ad6"]}</p>
        </div>
      </div>

      <div className="parallax" style={{backgroundImage: `url(/images/swiss_alpines.jpg)`}}>
        <div className="parallax-overlay">
          <h2><strong>{translations["mission.header"]}</strong></h2>
          <h3>{translations["mission.text"]}</h3>
        </div>
      </div>

      <div className="usecases-section">
        <h2><strong>{translations["use0"]}</strong></h2>
        <div className="usecases-grid">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <div className="usecase-card" key={i}>
              <img src={`/images/use${i}.jpg`} alt={`use${i}`}/>
              <span>{translations[`use${i}`]}</span>
            </div>
          ))}
        </div>
      </div>
      <Footer onTranslationsLoaded={setTranslations}/>
    </div>
  );
};

export default Landing;